import { prop } from 'ramda';
import ServiceFetcherCreate from './create';
import { TOKEN_REQUEST_OPTIONS, STORAGE_ACCESS_TOKEN_NAME } from './constants';

export default ServiceFetcherCreate({
  baseUrl: process.env.REACT_APP_API_URL_MINIMUM_PENSION,
  tokenUrl: process.env.REACT_APP_API_URL_TOKEN,
  tokenRequestOptions: TOKEN_REQUEST_OPTIONS,
  accessTokenGetter: () => localStorage.getItem(STORAGE_ACCESS_TOKEN_NAME),
  onError: (errorMessage) => {
    console.error(`[ServiceFetcher][onError]: ${errorMessage}`);
  },
  onGetToken: (response) => {
    localStorage.setItem(STORAGE_ACCESS_TOKEN_NAME, prop('access_token', response));
  }
});